








































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { uniqBy, differenceBy } from 'lodash';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import { ColDef } from 'ag-grid-community';

import AsociarFlotasIndividual from './AsociarFlotasIndividual.vue';
import AsociarEtiquetasIndividual from './AsociarEtiquetasIndividual.vue';
import AsociarVehiculos from '../AsociarFlotaEtiquetaVehiculo/AsociarVehiculos.vue';
import {
  Etiqueta,
  fetchFlotasEtiquetasVehiculos,
  Flota,
  Vehiculo,
} from '../AsociarFlotaEtiquetaVehiculo/fetchFlotasEtiquetasVehiculos';

enum TiposAsociacion {
  flota,
  etiqueta,
  vehiculo,
  vehiculoDejadoRecibir,
}

type Asociacion<T> = {
  todos: T[];
  seleccionados: T[];
};

export type AsociarFlotaEtiquetaVehiculoIndividualChangeEvent = {
  flotas: Flota[];
  etiquetas: Etiqueta[];
  vehiculos: Vehiculo[];
};

@Component({
  components: {
    StepTitle,
    AsociarVehiculos,
    AsociarEtiquetasIndividual,
    AsociarFlotasIndividual,
  },
})
export default class AsociarFlotaEtiquetaVehiculoIndividual extends Vue {
  @Prop({ default: false }) readonly: boolean;
  @Prop({ default: false }) esEditar: boolean;
  @Prop({ default: false }) esInforme: boolean;
  @Prop({default: false}) valideGps: boolean;
  @Prop({ default: (): [] => [] }) flotasIdSeleccionar: number[];
  @Prop({ default: (): [] => [] }) etiquetasIdSeleccionar: number[];
  @Prop({ default: (): [] => [] }) vehiculosIdSeleccionar: number[];
  @Prop({ default: (): [] => [] }) colDefVehiculo: Array<ColDef>;
  @Prop({ default: false }) filtroGps!: boolean;
  /* state */

  flotas: Asociacion<Flota> = {
    todos: [],
    seleccionados: [],
  };
  etiquetas: Asociacion<Etiqueta> = {
    todos: [],
    seleccionados: [],
  };
  vehiculos: Asociacion<Vehiculo> = {
    todos: [],
    seleccionados: [],
  };

  /* template */

  tiposAsociacion = TiposAsociacion;
  tipoAsociacion = TiposAsociacion.flota;
  vehiculoDDR: Vehiculo[];
  showDDR: boolean = false;

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  /* lifecycle hooks */

  mounted() {
    this.cargarData();
  }

  async cargarData() {
    const data = await this.fetchFlotasEtiquetasVehiculos();
    if (!data) {
      return;
    }

    const { etiquetas, flotas, vehiculos } = data;

    if (!this.filtroGps) {
      this.flotas.todos = flotas;
      this.etiquetas.todos = etiquetas;
      this.vehiculos.todos = vehiculos;
    } else {
      this.vehiculos.todos = vehiculos.filter(v => !v.poseeGps);
      this.flotas.todos = uniqBy(
        this.vehiculos.todos.map(x => x.flota),
        flota => flota.id
      );
      this.etiquetas.todos = uniqBy(
        this.vehiculos.todos.flatMap(x => x.etiquetas),
        etiqueta => etiqueta.id
      );
    }

    this.handleFlotasIdSeleccionarChange();
    this.handleEtiquetasIdSeleccionarChange();
    this.handleVehiculosIdSeleccionarChange();
  }

  emitChangeEvent() {
    const event: AsociarFlotaEtiquetaVehiculoIndividualChangeEvent = {
      flotas: this.flotas.seleccionados,
      etiquetas: this.etiquetas.seleccionados,
      vehiculos: this.vehiculos.seleccionados,
    };

    this.$emit('change', event);
  }

  /* event handlers */

  handleSelectedFlotasChange(flotas: Flota[]) {
    this.flotas.seleccionados = flotas;
    this.emitChangeEvent();
  }

  handleSelectedEtiquetasChange(etiquetas: Etiqueta[]) {
    this.etiquetas.seleccionados = etiquetas;
    this.emitChangeEvent();
  }

  handleSelectedVehiculosChange(vehiculos: Vehiculo[]) {
    this.vehiculos.seleccionados = vehiculos;
    this.emitChangeEvent();
  }

  /* fetch */

  fetchFlotasEtiquetasVehiculos() {
    this.loadingService.showLoading();
    return fetchFlotasEtiquetasVehiculos()
      .catch(() => {
        this.$snotify.error(
          `Ha ocurrido un error al intentar obtener flotas/etiquetas/vehiculos disponibles`,
          { timeout: 3000 }
        );
        return;
      })
      .finally(() => this.loadingService.hideLoading());
  }

  /* watcher */
  @Watch('flotasIdSeleccionar', { deep: true, immediate: true })
  handleFlotasIdSeleccionarChange() {
    if (this.flotasIdSeleccionar) {
      this.handleSelectedFlotasChange(
        uniqBy(
          [
            ...this.flotas.seleccionados,
            ...this.flotasIdSeleccionar
              .map(id => this.flotas.todos.find(x => x.id === id))
              .filter(x => x !== undefined),
          ],
          x => x.id
        )
      );
    }
  }

  @Watch('etiquetasIdSeleccionar', { deep: true, immediate: true })
  handleEtiquetasIdSeleccionarChange() {
    if (this.etiquetasIdSeleccionar) {
      this.handleSelectedEtiquetasChange(
        uniqBy(
          [
            ...this.etiquetas.seleccionados,
            ...this.etiquetasIdSeleccionar
              .map(id => this.etiquetas.todos.find(x => x.id === id))
              .filter(x => x !== undefined),
          ],
          x => x.id
        )
      );
    }
  }

  @Watch('vehiculosIdSeleccionar', { deep: true, immediate: true })
  handleVehiculosIdSeleccionarChange() {
    if (this.vehiculosIdSeleccionar) {
      this.handleSelectedVehiculosChange(
        uniqBy(
          [
            ...this.vehiculos.seleccionados,
            ...this.vehiculosIdSeleccionar
              .map(id => this.vehiculos.todos.find(x => x.id === id))
              .filter(x => x !== undefined),
          ],
          x => x.id
        )
      );
    }
  }
}
